export default __webpack_public_path__ + "static/pacifico-bull-cd8cbe306dff0b3b2f10014010bf7a34.webp";